export const tipoImovelID =
{
    Uniresidencial: "Uniresidencial",
    MultiresidencialAte4Pav: "MultiresidencialAte4Pav",
    MultiresidencialAcima4Pav: "MultiresidencialAcima4Pav",
    NaoResidencial: "NaoResidencial",
    CondominioLotes: "CondominioLotes",
    ERB: "ERB",
    GLP: "GLP",
    Loteamento: "Loteamento"
  }

export const tipoImovelNome =
{
    Uniresidencial: "Uniresidencial",
    MultiresidencialAte4Pav: "Multiresidencial até 4 pavimentos",
    MultiresidencialAcima4Pav: "Multiresidencial acima de 4 pavimentos",
    NaoResidencial: "Não residencial / misto",
    CondominioLotes: "Condomínio de lotes",
    ERB: "ERB",
    GLP: "GLP",
    Loteamento: "Loteamento"
}

export const tipoImovelIDFromNome =
{
    "Uniresidencial": "Uniresidencial",
    "Multiresidencial até 4 pavimentos": "MultiresidencialAte4Pav",
    "Multiresidencial acima de 4 pavimentos": "MultiresidencialAcima4Pav",
    "Não residencial / misto": "NaoResidencial",
    "Condomínio de lotes": "CondominioLotes",
    "ERB": "Especial",
    "GLP": "Especial",
    "Loteamento": "Loteamento"
}